import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { EvidenceTimesheetsPage } from '@/features/labour-evidence/timesheets-page';

const day = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined);

const searchSchema = z.object({
  start: day,
  end: day,
  worker: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/labour-evidence/timesheets')({
  validateSearch: searchSchema,
  component: EvidenceTimesheetsRoute,
});

function EvidenceTimesheetsRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <EvidenceTimesheetsPage
      projectId={projectId}
      filter={search}
      onFilter={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
